import React, {
    useState, useEffect, useCallback, useContext
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import {BreakpointTrackerContext} from "@jutro/layout";
import { useAuthentication } from 'gw-digital-auth-react';
import { ServiceRequestService } from 'gw-capability-servicerequest';
import {
    Loader, FormattedDate, DateValue
} from '@jutro/components';
import metadata from './MessagesPage.metadata.json5';
import {Link} from "gw-components-platform-react";
import {getMetadataByBreakPoint} from "../utils/breakpointUtil";

function MessagesPage() {
    const { authHeader } = useAuthentication();
    const [messagesData, setMessagesData] = useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const breakpoint = useContext(BreakpointTrackerContext);

    const formatMessages = useCallback((globalMessages) => {
        console.log(globalMessages.messages);
        setMessagesData(globalMessages.messages);
    }, []);

    const getDateModified = useCallback((items, index, { path: property }) => {
        if (typeof items[property] === 'undefined') {
            return '';
        }
        /*return <FormattedDate value={new Date(items[property])} format="short" />;*/
        return (
            <DateValue
                format="short"
                placeholder="-"
                showTime={false}
                value={items[property]}
            />
        );
    }, []);

    const getReferenceNumber = useCallback((items, index, { path: property, id }) => {
        return (
            <Link to={`/service-request-details/${items[id]}`}>
                {items[property]}
            </Link>
        );
    }, []);

    useEffect(() => {
        setLoadingState(true);
        ServiceRequestService.getMessagesForSpecialist(authHeader).then(
            formatMessages
        ).finally(() => {
            setLoadingState(false);
        });
        // disable re render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const override = {
        '@field': {
            labelPosition: 'left'
        },
        messageTable: {
            data: messagesData
        }
    };

    const resolvers = {
        /*resolveClassNameMap: styles*/
        resolveCallbackMap: {
            getDateModified: getDateModified,
            getReferenceNumber: getReferenceNumber
        }
    };

    return renderContentFromMetadata(getMetadataByBreakPoint(metadata, breakpoint), override, resolvers);
}

export default withRouter(MessagesPage);
